export abstract class NavigationUtility {

    public static navigateTo(level: NavigationLevel): any {
        document.getElementById(level)?.scrollIntoView({ behavior: 'smooth' });
    }
}

export enum NavigationLevel {
    Home = "profile",
    Portfolio = "portfolio",
    Resume = "resume",
    Contact = "contact",
}